<template>
  <div style="height: 100%;">
    <k-data-table fill-height :headers="headers" :items="templates" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <tr>
          <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.title }}</td>
          <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
          <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
          <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>
        </tr>
      </template>
    </k-data-table>
<!--    <action-buttons v-if="$is_admin()" @add="open_add_channel_group"></action-buttons>-->
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from '../BottomSheet'
import ActionButtons from '@/components/ActionButtons.vue'
export default {
  components: {
    BottomSheet,
    ActionButtons
  },
  data () {
    return {
      headers: [
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left', sortable: false }
      ],
      pagination: {
        sortBy: 'title',
        descending: true,
        rowsPerPage: 25
      },
      state_filters: ['active'],
      search_text: ""
    }
  },
  mounted () {
    this.$root.$on("channels:add", this.open_add_channel_group);
    this.$root.$on("channels:search", (search_text) => {
      this.search_text = search_text;
    });
  },
  beforeDestroy() {
    this.$root.$off("channels:add", this.open_add_channel_group);
    this.$root.$off("channels:search");
  },

  computed: {
/*    search_text () {
      return this.$store.state.search_text;
    },*/
    templates () {
      var ret = _.values(this.$store.state.channel_templates);
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      if (search.length > 0) {
        ret = _.filter(ret, function(template) {
          ret = false;
          if (template.title.toLowerCase().includes(search)) ret = true;
          if (template.name.toLowerCase().includes(search)) ret = true;
          if (template.uuid.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return ret;
    }
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_edit_channel_group(uuid) {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/configuration_presets/edit/"+uuid)
    },
    open_add_channel_group() {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/configuration_presets/new")
    }
  }
}
</script>